<template>
  <div v-viewButton :class="isCollapse ? 'main_menu_thin' : 'main_menu'">
    <div v-viewButton class="menu" :class="{ thin: isCollapse }">
		<rs-menu
		            class="sidebar-el-menu"
		            :default-active="onRoutes"
		            :collapse="collapse"
		            background-color="#0F1011"
		            text-color="#FFFFFF"
		            active-text-color="#3370FF"
		            unique-opened
		            router
		        >
		         <rs-menu-item index='index'>
		                   <i class="rs-icon-s-home" style="color: white;"></i>
		        <span slot="title">首页</span>
		          </rs-menu-item>
		          <rs-submenu index='renTal'>
		            <template slot="title">
		                            <i class="rs-icon-setting" style="color: white;"></i>
		                            <span slot="title">缴费中心</span>
		                        </template>
		               <rs-menu-item index='renTal'>
		                  <i class="rs-icon-spot"></i>  
		              <span slot="title">账单管理</span>
		               </rs-menu-item>
		               <rs-menu-item index='reconciLiation'>
		                   <i class="rs-icon-spot"></i>  
		                <span slot="title">对账管理</span>
		               </rs-menu-item>
		          </rs-submenu>
		          <rs-submenu index='MyHome'>
		            <template slot="title">
		                            <i class="rs-icon-user"  style="color: white;"></i>
		                            <span slot="title">用户中心</span>
		                        </template>
		               <rs-menu-item index='MyHome'>
		                   <i class="rs-icon-spot"></i>  
		        <span slot="title">商户信息</span>
		               </rs-menu-item>
		               <rs-menu-item index='UserList'>
		                   <i class="rs-icon-spot"></i>  
		        <span slot="title">我的用户</span>
		               </rs-menu-item>
					   <rs-menu-item index='UserAnnouncement'>
					           <i class="rs-icon-spot"></i>     
					   <span slot="title">用户公告</span>
					          </rs-menu-item>
		          </rs-submenu>
				  </rs-menu>
     <!-- <rs-menu
        class="rs-menu-vertical-demo"
        :collapse="isCollapse"
        :class="{ thin: isCollapse }"
        background-color="#0F1011"
        text-color="#FFFFFF"
        active-text-color="#3370FF"
        :unique-opened="true"
        :defaultActive="defaultActive"
        @select="selectItems($event)"
      >
        <div
          v-for="(item, index) in menu.childResourceVoList"
          :key="index"
          style="margin-top: 4px"
        >
          <rs-submenu
            :index=" item.resourceUrl"
            v-if="item.childResourceVoList !== null"
          >
            <template slot="title">
              <a
                :href="item.resourceUrl"
                @click.prevent="prevent"
              >
                <i class="font_family menuIcon" v-html="item.iconCode"></i>
                <span
                  class="title_span"
                  v-show="!isCollapse"
                  :class="{ paddingRight: !isCollapse }"
                  slot="title"
                  >{{ item.resourceName }}</span
                >
              </a>
            </template>
            <div
              v-for="(value, num) in item.childResourceVoList"
              :key="num"
              style="margin-top: 4px"
            >
              <rs-menu-item
                class="menuitem-sub"
                v-if="value.childResourceVoList == null"
                :index="value.resourceUrl"
                :key="num"
              >
                <a
                  :href="value.resourceUrl"
                  @click.prevent="prevent"
                  class=""
                  >{{ value.resourceName }}</a
                >
              </rs-menu-item>
              <rs-submenu
                v-else
                :index="value.resourceUrl"
                :popper-append-to-body="true"
              >
                <template slot="title">
                  <a
                    class="menuitem-sub"
                    :href="value.resourceUrl"
                    @click.prevent="prevent"
                  >
                    <span
                      class="title_span"
                      :class="{ paddingRight: !isCollapse }"
                      slot="title"
                      >{{ value.resourceName }}</span
                    >
                  </a>
                </template>
                <rs-menu-item
                  style="margin-top: 4px"
                  :index="val.resourceUrl"
                  v-for="(val, idx) in value.childResourceVoList"
                  :key="idx"
                >
                  <a
                    class="menuitem-thr"
                    :href="val.resourceUrl"
                    @click.prevent="prevent"
                    >{{ val.resourceName }}</a
                  ></rs-menu-item
                >
              </rs-submenu>
            </div>
          </rs-submenu>
          <rs-menu-item
            :index="item.resourceUrl"
            v-else
            :class="{ paddingRight: !isCollapse }"
          >
            <a
              :href="item.resourceUrl"
              @click.prevent="prevent"
            >
              <i class="font_family menuIcon" v-html="item.iconCode"></i>
              <span
                class="title_span"
                v-show="!isCollapse"
                :class="{ paddingRight: !isCollapse }"
                >{{ item.resourceName }}</span
              >
            </a>
          </rs-menu-item>
        </div>
      </rs-menu> -->
<!--     <rs-menu
        class="rs-menu-vertical-demo"
        :collapse="isCollapse"
        :class="{ thin: isCollapse }"
        background-color="#0F1011"
        text-color="#FFFFFF"
        active-text-color="#3370FF"
        :unique-opened="true"
          :default-active="$route.path"
        @select="selectItems($event)"
      
      >
        <div v-for="(item, index) in menu.childResourceVoList" :key="index" style="margin-top: 4px">
          <rs-submenu
            :index="item.resourceName + '&' + item.resourceUrl"
            v-if="item.childResourceVoList !== null"
          >
            <template slot="title">
              <a
                :href=" item.resourceUrl"
                @click.prevent="prevent"
              >
                <i class="font_family menuIcon" v-html="item.iconCode"></i>
                <span
                  class="title_span"
                  v-show="!isCollapse"
                  :class="{ paddingRight: !isCollapse }"
                  slot="title"
                  >{{ item.resourceName }}</span
                >
              </a>
            </template>
            <div
              v-for="(value, num) in item.childResourceVoList"
              :key="num"
              style="margin-top: 4px"
            >
              <rs-menu-item
                class="menuitem-sub"
                v-if="value.childResourceVoList == null"
                :index="value.resourceName + '&' + value.resourceUrl"
                :key="num"
              >
                <a
                  :href="value.resourceUrl"
                  @click.prevent="prevent"
                  class=""
                  >{{ value.resourceName }}</a
                >
              </rs-menu-item>
              <rs-submenu
                v-else
                :index="value.resourceName + '&' + value.resourceUrl"
                :popper-append-to-body="true"
              >
                <template slot="title">
                  <a
                    class="menuitem-sub"
                    :href="value.resourceUrl"
                    @click.prevent="prevent"
                  >
                    <span
                      class="title_span"
                      :class="{ paddingRight: !isCollapse }"
                      slot="title"
                      >{{ value.resourceName }}</span
                    >
                  </a>
                </template>
                <rs-menu-item
                  style="margin-top: 4px"
                  :index="val.resourceName + '&' + val.resourceUrl"
                  v-for="(val, idx) in value.childResourceVoList"
                  :key="idx"
                >
                  <a
                    class="menuitem-thr"
                    :href="val.resourceUrl"
                    @click.prevent="prevent"
                    >{{ val.resourceName }}</a
                  ></rs-menu-item
                >
              </rs-submenu>
            </div>
          </rs-submenu>
          <rs-menu-item
            :index="item.resourceName + '&' + item.resourceUrl"
            v-else
            :class="{ paddingRight: !isCollapse }"
          >
            <a
              :href="item.resourceUrl"
              @click.prevent="prevent"
            >
              <i class="font_family menuIcon" v-html="item.iconCode"></i>
              <span
                class="title_span"
                v-show="!isCollapse"
                :class="{ paddingRight: !isCollapse }"
                >{{ item.resourceName }}</span
              >
            </a>
          </rs-menu-item>
        </div>
      </rs-menu>
      <rs-menu
        class="rs-menu-vertical-demo"
        :collapse="isCollapse"
        :class="{ thin: isCollapse }"
        background-color="#0F1011"
        text-color="#FFFFFF"
        active-text-color="#3370FF"
        :unique-opened="true"
           :default-active="$route.path"
        @select="selectItems($event)"
      
      >
        <div v-for="(item, index) in menu.childResourceVoList" :key="index" style="margin-top: 4px">
          <rs-submenu
            :index="item.resourceName + '&' + item.resourceUrl"
            v-if="item.childResourceVoList !== null"
          >
            <template slot="title">
              <a
                :href="item.resourceUrl"
                @click.prevent="prevent"
              >
                <i class="font_family menuIcon" v-html="item.iconCode"></i>
                <span
                  class="title_span"
                  v-show="!isCollapse"
                  :class="{ paddingRight: !isCollapse }"
                  slot="title"
                  >{{ item.resourceName }}</span
                >
              </a>
            </template>
            <div
              v-for="(value, num) in item.childResourceVoList"
              :key="num"
              style="margin-top: 4px"
            >
              <rs-menu-item
                class="menuitem-sub"
                v-if="value.childResourceVoList == null"
                :index="value.resourceName + '&' + value.resourceUrl"
                :key="num"
              >
                <a
                  :href="value.resourceUrl"
                  @click.prevent="prevent"
                  class=""
                  >{{ value.resourceName }}</a
                >
              </rs-menu-item>
              <rs-submenu
                v-else
                :index="value.resourceName + '&' + value.resourceUrl"
                :popper-append-to-body="true"
              >
                <template slot="title">
                  <a
                    class="menuitem-sub"
                    :href="  value.resourceUrl"
                    @click.prevent="prevent"
                  >
                    <span
                      class="title_span"
                      :class="{ paddingRight: !isCollapse }"
                      slot="title"
                      >{{ value.resourceName }}</span
                    >
                  </a>
                </template>
                <rs-menu-item
                  style="margin-top: 4px"
                  :index="val.resourceName + '&' + val.resourceUrl"
                  v-for="(val, idx) in value.childResourceVoList"
                  :key="idx"
                >
                  <a
                    class="menuitem-thr"
                    :href="val.resourceUrl"
                    @click.prevent="prevent"
                    >{{ val.resourceName }}</a
                  ></rs-menu-item
                >
              </rs-submenu>
            </div>
          </rs-submenu>
          <rs-menu-item
            :index="item.resourceName + '&' + item.resourceUrl"
            v-else
            :class="{ paddingRight: !isCollapse }"
          >
            <a
              :href="item.resourceUrl"
              @click.prevent="prevent"
            >
              <i class="font_family menuIcon" v-html="item.iconCode"></i>
              <span
                class="title_span"
                v-show="!isCollapse"
                :class="{ paddingRight: !isCollapse }"
                >{{ item.resourceName }}</span
              >
            </a>
          </rs-menu-item>
        </div>
      </rs-menu> -->
    </div>
  </div>
</template>
<script>
import Utils from "@/utils/utils";
import Http from "@/api/api";
export default {
  data() {
    return {
			collapse: false,
	 activeKey: this.$route.path,
      staticId: 0,
      defaultActive: "/index",
	  menu: {
	    childResourceVoList: [
	     {
	       id: 2270,
	       resourceName: "首页",
	       resourceUrl: "/#/index",
	       iconCode: "&#xe65f;",
	       childResourceVoList: null,
	     },
	     {
	            id: 5,
	            iconCode: "&#xe606;",
	            resourceName: "缴费中心",
	     		    resourceUrl: "/#/renTal",
	     		  // resourceUrl: "/#/Depositlist",
	            childResourceVoList: [
	             // {
	             //   id: 8,
	             //   resourceName: "租赁缴费",
	             //   resourceUrl: "/#/arrEars",
	             //   iconCode: "&#xe606;",
	             //   childResourceVoList: null,
	             // },
	              {
	                id: 6,
	                resourceName: "账单管理",
	                resourceUrl: "/#/renTal",
	                iconCode: "&#xe606;",
	                childResourceVoList: null,
	              },
	    
	              
	              {
	                id: 13,
	                resourceName: "对账管理",
	                resourceUrl: "/#/reconciLiation",
	                iconCode: "&#xe606;",
	                childResourceVoList: null,
	              },
				  ],
				  },
	      {
	        id: 0,
	        resourceName: "用户中心",
	         iconCode: "&#xe609;",
	          resourceUrl: "/#/MyHome",
	        childResourceVoList: [
	          {
	            id: 1,
	            resourceName: "商户信息",
	            resourceUrl: "/#/MyHome",
	            iconCode: "&#xe606;",
	            childResourceVoList: null,
	          },
	          {
	            id: 2,
	            resourceName: "我的用户",
	            resourceUrl: "/#/UserList",
	            iconCode: "&#xe606;",
	            childResourceVoList: null,
	          },
	          {
	            id: 3,
	            resourceName: "平台公告",
	            resourceUrl: "/#/UserAnnouncement",
	            iconCode: "&#xe606;",
	            childResourceVoList: null,
	          },
	        ],
	      },
	    ],
    }
  }
  },
mounted() {
	
	
	
},
computed:{
   onRoutes() {
            return this.$route.path.replace('/', '');
        }
},
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
   // 检测路由变化
    // watch: {
    //   $route() {
    //     this.setCurrentRoute();
    //   }
    // },
  created: function () {
	  	bus.$on('collapse', (msg) => {
	              this.collapse = msg;
	              bus.$emit('collapse-content', msg);
	          });
    this.bbtn();
	// this.staticId=localStorage.getItem('styid')
	this.byn()
	console.log(this.defaultActive)
	// this.setCurrentRoute();
  },
  //路由跳转时，检测变化

  //       watch: {
  //   $route(to, from) {
  //     if (to.query.id != from.query.id) {
  //       this.id = to.query.id;
  //       console.log(this.id)
  //       this.init(); //重新加载数据
  //     }
  //   },
  // },
  methods: {
	  byn:function(){
		this.bus.$on('styid',(id)=>{
	  this.staticId=id
	  console.log(id)
  })  
	  },
	  //  setCurrentRoute() {
	  //       this.activeIndex= this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
			// console.log(this.activeIndex)
	  //     },
    bbtn: function () {
      this.bus.$on("sendId", (id) => {
        this.staticId = id;
      });
    },
    // selectItems(index) {
    //   if (index.split("&")[1] !== "" || index.split("&")[1] !== null) {
    //     if (
    //       index.split("http://").length > 0 ||
    //       index.split("https://").length > 0
    //     ) {
    //       //外网链接
    //       this.$emit("jumpUrl", index, "http");
    //     } else {
    //       this.$emit("jumpUrl", index);
    //     }
    //   }
    //   Utils.setSession("leftMenuInit", index);
    // },
    // getTree() {
    //   Http.getMenuResource({userId: Utils.getSession("userInfo").id}).then(res => {
    //       let getData = JSON.parse(JSON.stringify(res.data.data));
    //       this.menu = JSON.parse(JSON.stringify(getData));
    //       this.menu.childResourceVoList = [];
    //       this.menu.childResourceVoList = JSON.parse(JSON.stringify(getData.childResourceVoList));
    //       this.menu = res.data.data
    //       this.defaultActive = Utils.getSession('leftMenuInit',false)
    //       this.$emit('getMenuResource', this.menu.childResourceVoList)
    //   }).catch(()=>{
    //   })
    // },
    setImg() {
      let img = Utils.getLocalStorage("imgUrl");
      if (img) {
        img.forEach((v) => {
          if (v.imageType === 3) {
            this.logoImg = v.imageUrl;
          }
        });
      }
    },
    getButton() {
      Http.getButtonResource().then((res) => {
        Utils.setSession("buttonResource", res.data.data);
      });
    },
    postMessageListener(e) {
      const vm = this;
      if (e.data.type === "uploadImg") {
        vm.setImg();
      }
    },
    prevent(event) {
      event.preventDefault();
    },
  },
  mounted() {
    window.addEventListener("message", this.postMessageListener);
    // this.getTree(); //获取树型结构
    // this.getButton();
    this.setImg();
  },
};
</script>
<style lang='scss' scoped>
.menu {
  z-index: 5;
  height: 100%;
  transition: all 0.1s;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  overflow: auto;
  background: #0f1011;
  padding: 0 4px;
}
.menu.thin {
  width: 50px;
  overflow-x: hidden;
}
.thin .menu_div {
  left: 50px;
}

.title_span {
  display: inline-block;
  text-align: left;
}
.thin .rs-icon-arrow-right {
  display: none;
}
.rs-submenu__icon-arrow {
  position: absolute;
  right: 7px;
  opacity: 0.8;
}
.rs-submenu__icon-arrow::before {
  content: "\e790";
  color: #fff;
}
.rs-menu {
  border: 0;
/*  text-align: center; */
  background: #f9f9f9;
}
.rs-menu-item.is-active,
.menu .is-active,
.rs-menu-item.is-active:hover {
  background: #3370ff !important;
  border-radius: 4px;
  color: #fff !important;
}
.rs-menu-item.is-active a {
  color: #fff;
}
/deep/.rs-menu--collapse {
  width: 47px;
}
.main_menu {
  /* box-shadow: 2px 0px 4px 0 rgba(0,21,41,0.12); */
  /* margin-right:4px; */
  height: 100%;
  overflow: auto;
  width: 12%;
  min-width: 200px;
  max-width: 250px;
}
.main_menu_thin {
  height: 100%;
  overflow: auto;
}
/deep/.rs-menu-item,
/deep/.rs-submenu__title {
  height: 40px !important;
  line-height: 39px !important;
  padding: 0 8px !important;
}
/deep/ .menu > .rs-menu > div > .is-opened > .rs-submenu__title i {
  color: #fff;
}
.menu > .rs-menu > div > .is-opened > .rs-submenu__title span {
  color: #fff;
}
/deep/.rs-menu-item i,
.rs-submenu__title a i {
  margin-right: 8px;
  margin-top: -2px;
}
.rs-menu-item {
  padding: 0 8px !important;
}
.thin .rs-menu-item.is-active {
  background: transparent !important;
}
.thin .rs-menu-item.is-active i {
  background: #3370ff !important;
}
/deep/.thin .rs-menu-item:hover,
/deep/.thin .rs-submenu__title {
  width: 40px;
}
/deep/.rs-submenu__title:hover,
.rs-menu-item:hover {
  background: rgba(51, 112, 255, 0.2) !important;
  border-radius: 4px;
}
a {
  color: #ffffff;
}
::-webkit-scrollbar {
  width: 1px;
}
.menuIcon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #fff !important;
  border-radius: 4px;
  text-align: center;
  margin-right: 16px;
  background: rgba(255, 255, 255, 0.15);
}
.menuitem-sub:before {
  content: "";
  background-color: #7c878e;
  width: 4px;
  height: 4px;
  border-radius: 10px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: text-top;
  margin-top: 6px;
  margin-left: 9px;
}
.menuitem-sub.is-active:before {
  background-color: #ffffff;
}
.menuitem-thr:before {
  content: "";
  background-color: #7c878e;
  margin-right: 42px;
  display: inline-block;
  vertical-align: text-top;
  margin-top: 8px;
  margin-left: 6px;
}
.rs-menu--popup .menuitem-thr:before,
.rs-menu--popup .menuitem-sub:before {
  display: none;
}
.rs-menu.rs-menu--popup .rs-menu-item {
  margin: 0 4px;
}
/deep/.rs-icon-arrow-right::before {
  content: "\e791";
  color: #fff;
}
/deep/.is-opened .rs-icon-arrow-right {
  transform: rotate(0deg) !important;
}
</style>